(ns practitest.frontend.common.utils
  #?(:cljs (:require-macros [practitest.frontend.common.utils] ))
  #?(:clj (:require [clojure.string :as str]
                    [cljs.env :as env])
     :cljs (:require [goog]
                     [clojure.walk :as walk]
                     [practitest.frontend.common.uri :refer [set-query-param]])))

(defmacro register-webcomponent!
  "Special macro to register webcomponent (only if class is defined).

  Must be used with `frontend_webcomponent` helper in Rails part"
  [component]
  (let [classname (symbol
                    "js"
                    (str/join
                      (map str/capitalize
                           (str/split component #"-"))))]
    `(when (cljs.core/js-fn? ~classname)
       (when (cljs.core/undefined? (js/window.customElements.get ~component))
         (js/window.customElements.define ~component ~classname)))))

#?(:cljs (def ^{:goog-define "boolean"} DEV_MODE (goog/define "practitest.DEV_MODE" false)))

(defn in-dev-mode? []
  #?(:cljs DEV_MODE
     :clj (get-in @env/*compiler* [:options :closure-defines 'practitest.DEV_MODE])))

;; Special dynamic var to control tracing output per-component
#?(:cljs (def ^:dynamic *enable-trace* false))

;; To trace popover behavior
;; Enable trace statements
(defmacro trace
  [& args]
  (when (in-dev-mode?)
    `(when *enable-trace*
       (js/console.log ~@args))))

(defmacro dbg [body]
  `(let [x# ~body]
     (js/console.log "dbg:" '~body "=" x#)
     x#))

;; TODO: with-meta ?
(defmacro example
  [& body]
  `[:div.component-example-instance
    [:pre ~(str (first body))]

    ~@body])

(defmacro development-only
  [& body]
  (when (in-dev-mode?)
    `(do
       ~@body)))

(defmacro register-components!
  "Register all components and examples (marked with `:component?` and
  `:component-example` meta) inside a namespace.

  This code will be stripped out on production build automatically"
  []
  (let [ns-info (get-in @env/*compiler* [:cljs.analyzer/namespaces (.getName *ns*)])
        definitions (vals (:defs ns-info))
        components (filter #(:component? (:meta %)) definitions)
        examples (filter #(:component-example (:meta %)) definitions)]

    `(development-only
       (require 'practitest.dev.auto-components)

       ~@(for [c components]
           `(practitest.dev.auto-components/register-component! (quote ~(:name c))
                                                                (var ~(:name c))))

       ~@(for [e examples]
           `(practitest.dev.auto-components/register-example! (symbol (var ~(:component-example (:meta e))))
                                                              (var ~(:name e)))))))

(defn email? [s]
  (boolean (and s (re-matches #"[^@\s]+@[^@\s]+\.[^@\s]+" s))))

(defn remove-nils [m]
  (into {} (remove (comp nil? val) m)))

(defn index-by-field-value
  "Returns the index of the first element in vec where (get element field) equals value."
  [vec field value]
  (first (keep-indexed
          (fn [idx element]
            (when (= (get element field) value)
              idx))
          vec)))







